import { CheckCircle, LucideIcon } from "lucide-react"

interface Step {
  title: string
  icon: LucideIcon
}

interface FormStepIndicatorProps {
  steps: Step[]
  currentStep: number
}

export function FormStepIndicator({ steps, currentStep }: FormStepIndicatorProps) {
  return (
    <div className="flex justify-center mb-8">
      <div className="flex items-center gap-2 bg-slate-100 rounded-full px-6 py-3">
        <div className="flex items-center gap-1">
          {steps.map((step, index) => {
            const StepIcon = step.icon
            return (
              <div key={index} className="flex items-center">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-300 ${
                  index <= currentStep ? 'bg-[#FF7A00] text-white' : 'bg-slate-200 text-slate-500'
                } ${index === currentStep ? 'ring-2 ring-[#FF7A00] ring-offset-2' : ''}`}>
                  {index < currentStep ? (
                    <CheckCircle size={16} />
                  ) : (
                    <StepIcon size={16} />
                  )}
                </div>
                {index < steps.length - 1 && (
                  <div className={`w-8 h-0.5 mx-1 transition-all duration-300 ${
                    index < currentStep ? 'bg-[#FF7A00]' : 'bg-slate-200'
                  }`} />
                )}
              </div>
            )
          })}
        </div>
        <div className="ml-4 text-left">
          <div className="text-xs font-medium text-slate-600">Step {currentStep + 1} of {steps.length}</div>
          <div className="text-sm font-semibold text-slate-800">{steps[currentStep].title}</div>
        </div>
      </div>
    </div>
  )
}
